export default __webpack_public_path__ + "static/media/1381.53cf9655.png";